import { fromClass } from "fw-model";
import { SearchResult } from "./search-result";
import { SelectionItem } from "./definitions";

export enum ExportDetailsTabs {
    GeneralInformation = 0,
    FailedDeliveries = 1,
    DeliveredFiles = 2,
    FilesToDeliver = 3
}

export enum DataType {
    Application = 0,
    Contact = 1,
    User = 2
}

export enum Format {
    JSON = 0,
    PDF = 1,
    Tabular = 2,
    Files = 3
}

export enum ExportStatuses {
    Requested = 0,
    Running = 1,
    Complete = 2,
    Error = 3,
    PendingPackaging = 4,
    PendingDelivery = 5,
    DeliveryError = 6,
    Empty = 7
}

export enum ExportFrequency {
    Always = 0,
    OnlyOnce = 1
}

export type Filter = {
    organization?: string;
    format?: number;
    type?: number;
    status?: number;
    range?: string | [];
    missing?: string;
    exportFrequency?: number;
};
export type OrganizationFilter = {
    type?: number;
    tags?: string[];
};
export type HeadersType = {
    label: string;
    sort?: string;
    key?: string;
    class?: string;
};

export type SortParamsType = {
    column: string;
    order: "asc" | "desc";
};

export type Flag = {
    open: boolean;
};

export type TabsType = {
    label: string;
    value: number;
};

export type StatusAggregationItem = {
    Key: number;
    Total: number;
};

export class ExportTaskSearchResult extends SearchResult<AtsExportTaskInfo> {}

export class AtsDeliveryOptions {
    FileProviderId: string;
    FileProviderFolder: string;
    ShouldZipContents: boolean;
    ZipFileNameFormat: string;
    ZipFileCount: number;
    ZipEachChildTask: boolean;
}

export class AtsExportDefinition {
    Name: string;
    DataType: DataType;
    Format: Format;
    FileNameFormat: string;
}
export class AtsFileDeliveryInfo {
    FileId: string;
    VirtualPath: string;
    RecordCount: number;
    DeliveryFailureMessage: string;
    AlternateFileName: string;
}

export class AtsExportScheduleInfo {
    ExportFrequency: AtsExportRecordFrequency;
    WatchFieldPath: string;
}

export class AtsExportTaskMetaData {
    OrganizationId: string;
    SeasonId: string;
    ScheduledExportId: string;
    ActorType: string;
    ActorId: string;
    RoleId: string;
    TriggerType: string;
    TriggerId: string;
    TaskRequestId: string;
    ExportDefinitionId: string;
    DateStartedUtc: Date;
    DateCreatedUtc: Date;
    IdCount: number;
    ZipFileNameWithAggregateFields: string;
    Status: ExportStatuses;
    StatusMessage: string;
    Duration: number;
    ProcessingTime: number;
    ProcessingTimePerRecord: number;
    ScheduleDelay: number;
    ProcessingDelay: number;
    TotalDelay: number;
    TotalTimeInQueue: number;
    QueueKey: string;
    @fromClass ScheduleInfo: AtsExportScheduleInfo;
    DeliveryDelay: number;
    @fromClass FailedDeliveries: AtsFileDeliveryInfo[];
    @fromClass FilesToDeliver: AtsFileDeliveryInfo[];
    @fromClass DeliveredFiles: AtsFileDeliveryInfo[];
}
export class AtsExportTask {
    Id: string;
    @fromClass Delivery: AtsDeliveryOptions;
    @fromClass Definition: AtsExportDefinition;
    @fromClass MetaData: AtsExportTaskMetaData;
}
export class AtsExportTaskInfo {
    @fromClass ExportTask: AtsExportTask;
    OrganizationId: string;
    OrganizationName: string;
}

export enum AtsExportRecordFrequency {
    Always = 0,
    OnlyOnce = 1
}

export const EXPORT_STATUSES: SelectionItem[] = [
    { label: "All Statuses", value: null },
    { label: "Requested", value: ExportStatuses.Requested, color: "pending-color", hexColor: "#fde68a" },
    { label: "Running", value: ExportStatuses.Running, color: "pending-color", hexColor: "#fde68a" },
    { label: "Complete", value: ExportStatuses.Complete, color: "complete-color", hexColor: "#a7f3d0" },
    { label: "Error", value: ExportStatuses.Error, color: "error-color", hexColor: "#fecaca", styleColor: "#7f1d1d" },
    { label: "Pending Packaging", value: ExportStatuses.PendingPackaging, color: "pending-color", hexColor: "#fde68a" },
    { label: "Pending Delivery", value: ExportStatuses.PendingDelivery, color: "pending-color", hexColor: "#fde68a" },
    { label: "Delivery Error", value: ExportStatuses.DeliveryError, color: "error-color", hexColor: "#fecaca" },
    { label: "Empty", value: ExportStatuses.Empty, color: "empty-color", hexColor: "#e5e7eb" }
];

export const METRIC_TYPES = [
    { label: "Duration", value: "avg_metaData.duration", hexColor: "#5571AD" },
    { label: "Processing Time Per Record", value: "avg_metaData.processingTimePerRecord", hexColor: "#b4bd00" },
    { label: "Processing Time", value: "avg_metaData.processingTime", hexColor: "#55b8d4" },
    { label: "Total Delay", value: "avg_metaData.totalDelay", hexColor: "#4eaf9c" },
    { label: "Schedule Delay", value: "avg_metaData.scheduleDelay", hexColor: "#f18eab" },
    { label: "Delivery Delay", value: "avg_metaData.deliveryDelay", hexColor: "#98a6ad" },
    { label: "Processing Delay", value: "avg_metaData.processingDelay", hexColor: "#e78747" },
    { label: "Total Time In Queue", value: "avg_metaData.totalTimeInQueue", hexColor: "#55b8d4" }
];

export function getStatusName(index): string {
    return EXPORT_STATUSES.find((item) => item.value === index)?.label;
}

export function getStatusColor(index): string {
    return EXPORT_STATUSES.find((item) => item.value === index)?.color ?? "pending-color";
}
